import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from 'react-bootstrap';
import Login from './pages/Login';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';

class Main extends React.Component {
  state = { user: null }

  loggedIn(u) {
    this.setState({ user: u });
  }

  render() {
    return (
      <Router>
        <div className="App">
          <header className="App-header">
            <div className="App" style={{ marginTop: '5px', marginBottom: '5px' }}>
              <Container>
                <h3 className='title'>Resource Telescope</h3>
              </Container>
            </div>
            <Switch>
              <Route path="/dashboard">
                <Dashboard user={this.state.user} />
              </Route>
              <Route path="/login">
                <Login onLoggedIn={u => this.loggedIn(u)} />
              </Route>
              <Route path="/">
                <Home />
              </Route>
            </Switch>
          </header>
        </div>
      </Router>
    );
  }
}

function App() {
  return <Main />
}

export default App;
